import { useState } from 'react';
import { navigate } from '../lib/router';
import { createRoom } from '../net/api';

export function Landing() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function start() {
    setBusy(true);
    setError(null);
    try {
      navigate(`/r/${await createRoom()}`);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Could not create a room.');
      setBusy(false);
    }
  }

  return (
    <main className="landing">
      <div className="landing__card">
        <h1 className="landing__title">Battlequip</h1>
        <p className="landing__pitch">Get them to say your words.</p>
        <p className="landing__sub">Don&rsquo;t say them yourself.</p>

        <button
          type="button"
          className="button button--primary button--big"
          onClick={start}
          disabled={busy}
        >
          {busy ? 'Starting…' : 'Start'}
        </button>

        {error && (
          <p className="landing__error" role="alert">
            {error}
          </p>
        )}

      </div>
    </main>
  );
}
